enum SourceAction {
    FORM_SUBMISSION = 'form_submission',
    VEHICLE_CHANGE = 'vehicle_change',
    COPY = 'copy',
}

export default SourceAction
